export const hasIn = (prop, obj) => {
    if (!obj) return false;
    if (typeof obj !== "object") return false;
    if (Array.isArray(obj)) return false;

    return prop in obj;
}
